import React, { FC } from 'react'
import { Box, SecondaryButton } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useFindLocaleText } from '../../../../text-localisation/localeTextProvider'
import { NAV_BUTTON_SIZE, NAV_BUTTON_SIZE_MOBILE } from '../constants'

const StyledPageListItem = styled(Box)<{ $hiddenInCondensedView?: boolean }>`
  ${({ $hiddenInCondensedView }) =>
    $hiddenInCondensedView &&
    s({
      display: { xs: 'none', md: 'block' },
    })}
`

const StyledPageButton = styled(SecondaryButton)`
  ${s({
    width: { xs: NAV_BUTTON_SIZE_MOBILE, md: NAV_BUTTON_SIZE },
    height: { xs: NAV_BUTTON_SIZE_MOBILE, md: NAV_BUTTON_SIZE },
    minHeight: { xs: NAV_BUTTON_SIZE_MOBILE, md: NAV_BUTTON_SIZE },
    borderRadius: 2,
    border: 0,
    boxShadow: 0,
  })}
  &:not(:disabled):hover,
  &:hover {
    ${s({
      bgcolor: 'colorBackground02',
      boxShadow: 0,
    })}
  }
  &:disabled {
    ${s({
      bgcolor: 'colorBackground03',
      color: 'colorTextAlternate',
    })}
  }
`

type PageButtonProps = {
  page: number
  currentPage: number
  hiddenInCondensedView?: boolean
  onClick: (event: React.MouseEvent<HTMLElement>, page: number) => void
  getPageHref: (page: number) => string
  localiseText: ReturnType<typeof useFindLocaleText>
}

export const PageButton: FC<PageButtonProps> = ({
  page,
  currentPage,
  hiddenInCondensedView,
  onClick,
  getPageHref,
  localiseText,
}) => {
  const isCurrentPage = page === currentPage

  return (
    <StyledPageListItem
      as="li"
      key={page}
      $hiddenInCondensedView={hiddenInCondensedView}
    >
      {isCurrentPage ? (
        <StyledPageButton disabled aria-current="page">
          {page}
        </StyledPageButton>
      ) : (
        <StyledPageButton
          href={getPageHref(page)}
          aria-label={localiseText('find.pagination_go_to_page', {
            page,
          })}
          onClick={event => onClick(event, page)}
        >
          {page}
        </StyledPageButton>
      )}
    </StyledPageListItem>
  )
}
